import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Sabés qué vas a comer antes de abrir la heladera', 'Cocinás en menos de 20 minutos con ingredientes simples', 'Dejás de depender del delivery para comer rico', 'Usás tu air fryer todos los días, no solo los fines de semana', 'Comés más liviano sin hacer dieta ni prohibirte nada'];
  return <section className="py-20 px-4 bg-white" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <div className="inline-flex bg-brand-purpleLight text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6" data-id="element-205">
            La solución
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray mb-6" data-id="element-206">
            Presentamos <br className="hidden sm:block" data-id="element-207" />
            <span className="italic text-brand-purple" data-id="element-208">
              "Recetas en Air Fryer ricas, sanas y fáciles"
            </span>
          </h2>
          <p className="text-xl text-brand-mediumGray max-w-3xl mx-auto font-medium" data-id="element-209">
            Un ebook diseñado específicamente para personas que tienen poco
            tiempo, no quieren complicarse y quieren sacarle el máximo provecho
            a su freidora.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-210">
          <div className="order-2 md:order-1" data-id="element-211">
            <div className="space-y-4" data-id="element-212">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 bg-white p-5 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-213">
                  <div className="bg-brand-yellow w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-214">
                    <Check className="w-5 h-5 text-brand-purpleDark" strokeWidth={3} data-id="element-215" />
                  </div>
                  <p className="text-brand-darkGray font-semibold text-lg leading-snug pt-0.5" data-id="element-216">
                    {benefit}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="order-1 md:order-2 flex justify-center" data-id="element-217">
            <img src="https://cdn.magicpatterns.com/uploads/gvNRSBs7CPvvhShmiBmZAh/AC358B5D-8A9E-4683-8767-26B49CF693EA.png" alt="Ebook Recetas en Air Fryer" className="w-full max-w-md drop-shadow-2xl" data-id="element-218" />
          </div>
        </div>
      </div>
    </section>;
}